import { render, staticRenderFns } from "./AIClassification.vue?vue&type=template&id=02372f17"
import script from "./AIClassification.vue?vue&type=script&lang=js"
export * from "./AIClassification.vue?vue&type=script&lang=js"
import style0 from "./AIClassification.vue?vue&type=style&index=0&id=02372f17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports